import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import GradesGoalGraph from 'components/Fragments/GradesGoalGraph/GradesGoalGraph';
import Label from 'components/form/Label/Label';
import { useConfig } from 'hook/config.hook';
import { FACTOR_ENUMS } from 'pages/RedesignDashboard/constants';

const CreditInquiriesSummaryModuleView = props => {
  const { CREDIT_INQUIRIES } = FACTOR_ENUMS;
  const { creditInquiriesSummary } = props;
  const { config } = useConfig();

  const label =
    config?.summaryHeaders?.[CREDIT_INQUIRIES][
      creditInquiriesSummary?.grade || 'DEFAULT'
    ];

  return (
    <FlexContainer className={'flex-column padLR48 m-padLR16 padTB24'}>
      <FlexContainer>
        <Label type="Body-2">{label}</Label>
      </FlexContainer>
      <FlexContainer className={'flex-column items-align-center padT24 padB32'}>
        <Label type="HeadingBold">
          {creditInquiriesSummary?.totalInquiriesInPast12Months}
        </Label>
        <Label type="Subtitle-2">
          {config?.creditInquiriesSummary?.subtitle}
        </Label>
      </FlexContainer>
      <FlexContainer>
        <GradesGoalGraph
          gradesGoalClasses={'width100'}
          textClasses={'subTitle4'}
          you={creditInquiriesSummary?.grade}
          type="inquiries"
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default CreditInquiriesSummaryModuleView;
